import React from 'react';

const Card = ({ children, className = '' }) => (
  <section className={`bg-card border border-line rounded-xl overflow-hidden ${className}`}>
    {children}
  </section>
);

export default Card;
